import {Component, ElementRef, Inject, Injector, HostListener, ViewChild} from '@angular/core';
import {NgbActiveModal, NgbModalRef, NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {AppComponentBase} from '../../../services/AppComponentBase';
import {IAppStoreProduct} from '../interfaces/appstore-interfaces';
import {StarRatingComponent} from 'ng-starrating';
import {showBuyingProcessModal} from '../appproduct-buypopup/appproduct-buypopup-modal';
import {AppProductView} from '../appproduct-view/appProductView.component';





@Component({
    selector: "mobile-modal-AppProductView",
    template: require('./mobile-appProductView.component.html'),
    styles: [require('./mobile-appProductView.component.css')]
})

export class MobileAppProductView extends AppProductView {
   

}


